import axios from 'axios';
import { createAPIService } from './api.service';

export const CONSUMER_CONFIGURATION_ENDPOINT =
  '/configurations/programs/consumer';

export const LOOKUP_ENDPOINT = id => `configurations/lookups/${id}/execute`;

const service = createAPIService('/config/api/');

// endpoints
service.getConsumerConfiguration = async () => {
  const response = await axios.get('config.json', {
    baseURL: '/',
  });
  return response.data;
};

service.lookup = async id => {
  const response = await service.get(LOOKUP_ENDPOINT(id));
  return response.data;
};

export default service;
